import type { SubprocesStatus } from '../../../../entity/subprocessen/types/Subproces'
import { SubprocesTypes } from '../../../../entity/subprocessen/types/Subproces'
import { getStatusLabelForType } from '../../../../entity/subprocessen/util/subproces-util'
import { initialState } from '../../../subprocessen/services/searchSubprocessen'
import { useWerklijsten } from '../../hooks/useWerklijsten'
import type { OnClickTile } from '../../types/DashboardNavigation'
import { DashboardCard } from '../DashboardCard'
import { KpiButton } from '../KpiButton'
import { pickWerklijstFilters } from '../werklijsten/werklijst-util'

interface Props {
  type: string
  status: string
  count: number
  red: number
  amber: number
  green: number
  onClickTile: OnClickTile
}

export default function SubprocesTile({
  type,
  status,
  count,
  onClickTile,
  red,
  amber,
  green,
}: Props) {
  const { filters } = useWerklijsten()

  const statusLabel = getStatusLabelForType(
    type as keyof typeof SubprocesTypes,
    status as keyof typeof SubprocesStatus,
  )

  const onClick = (kpiColor?: string) => {
    onClickTile({
      url: '/aansluiting/subprocessen',
      query: {
        filters: {
          ...initialState.query.filters,
          ...pickWerklijstFilters(filters),
          type: [{ code: type, label: SubprocesTypes[type] }],
          status: [{ code: status, label: statusLabel }],
          kpi: kpiColor ?? '',
        },
        page: initialState.query.page,
        sort: initialState.query.sort,
      },
    })
  }

  return (
    <DashboardCard
      onClick={() => {
        onClick()
      }}
      label={statusLabel}
      count={count}
      actions={
        <>
          {red > 0 && (
            <KpiButton
              color={'red'}
              count={red}
              onClick={(e) => {
                e.stopPropagation()
                onClick('red')
              }}
            />
          )}
          {amber > 0 && (
            <KpiButton
              color={'amber'}
              count={amber}
              onClick={(e) => {
                e.stopPropagation()
                onClick('amber')
              }}
            />
          )}
          {green > 0 && (
            <KpiButton
              color={'green'}
              count={green}
              onClick={(e) => {
                e.stopPropagation()
                onClick('green')
              }}
            />
          )}
        </>
      }
    />
  )
}
